/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import DayPicker from 'react-day-picker';
import TimePicker from 'rc-time-picker';
import moment from 'moment';

import { toggleOptionCard } from '../../../../actions/ViewController';
import { updateField } from '../../../../actions/BookingRequest';
import { getTime } from '../../../../api/DataHandlers';
import NumberOfWorkersSpinner from '../numberofworkersspinner';
import { jobModes } from '../../../../consts';
import { getOngoingJobDates } from '../../ongoingJobDates';

class AgentTimeDateCard extends Component {
    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.onStartChange = this.onStartChange.bind(this);
        this.onEndChange = this.onEndChange.bind(this);
        this.handleOngoingToggle = this.handleOngoingToggle.bind(this);
        this.breaksInput = React.createRef(null);
        this.daypickerRef = React.createRef(null);
    }

    componentDidMount() {
        this.breaksInput.current.value = null;
    }

    checkDateTimeValid(date, time) {
        const dateTime = `${date} ${time}`;
        const m = moment(dateTime, 'YYYY-MM-DD HH:mm');
        return m.isAfter(this.props.minStart);
    }

    handleDayClick(day) {
        const date = moment(day).format('YYYY-MM-DD');
        const time = this.props.start_time;
        if (this.checkDateTimeValid(date, time)) {
            this.props.updateField('date', date);
            if (this.props.isMultiple) {
                this.props.updateField('dates', getOngoingJobDates(date));
            }
        }
        if (this.props.calendarOnly) {
            this.props.toggleOptionCard();
        }
    }

    handleOngoingToggle(event) {
        const { checked } = event.target;
        const { date, dates } = this.props;

        if (checked) {
            this.props.updateField('isMultiple', true);
            this.props.updateField('dates', getOngoingJobDates(date));
        } else {
            const startDate =
                dates?.length > 0
                    ? [...dates].sort((a, b) => moment(a) - moment(b))[0]
                    : date;
            this.props.updateField('isMultiple', false);
            this.props.updateField('date', startDate);
            this.props.updateField('dates', []);
            this.props.updateField('rangeDatesSelected', []);
        }
    }

    onStartChange(value) {
        const { date, dates, isMultiple } = this.props;
        let selectedDate = date;
        if (dates?.length > 0 && isMultiple) {
            [ selectedDate ] = dates.sort((a, b) => moment(a) - moment(b));  // earliest date
        }
        const time = value && value.format('HH:mm');
        if (this.checkDateTimeValid(selectedDate, time)) {
            this.props.updateField('start_time', time);
        }
    }

    onEndChange(value) {
        const end = value && value.format('HH:mm');
        let duration = moment
            .duration(end)
            .subtract(this.props.start_time, 'HH:mm')
            .as('hours');

        if (duration < 0 && duration >= -24) {
            duration += Number(24);
        }
        if (duration >= 1 && duration <= 16)
            this.props.updateField('duration', duration);
    }

    onMinutePickerOpen(value) {
        if (value.open) {
            setTimeout(() => {
                document
                    .querySelector('.rc-time-picker-panel')
                    .classList.add('minute-picker-panel');
            });
        }
    }

    breaksHandler = e => {
        const value = e.target.value === '' ? null : Math.floor(e.target.value);
        this.props.updateField('breaks', value);
    };

    render() {
        const { isMultiple, mode, breaks } = this.props;
        let modifiers = {
            past: {
                before: new Date(this.props.minStart),
            },
            nextMonth: day => {
                if (this.daypickerRef.current) {
                    return moment(day).isAfter(
                        moment(this.daypickerRef.current.state.currentMonth),
                        'month',
                    );
                }
                return null;
            },
            previousMonth: day => {
                if (this.daypickerRef.current) {
                    return moment(day).isBefore(
                        moment(this.daypickerRef.current.state.currentMonth),
                        'month',
                    );
                }
                return null;
            },
        };
        const days = this.props.dates || [];
        const start_time =
            this.props.start_time == null
                ? getTime(this.props.minStart)
                : this.props.start_time;
        const startTime = moment(start_time, 'HH:mm');
        const endTime = moment(start_time, 'HH:mm').add(this.props.duration, 'h');
        let selectedDays;
        if (isMultiple) {
            selectedDays = day =>
                days.includes(moment(day).format('YYYY-MM-DD'));
            modifiers = {
                ...modifiers,
                'selected-right': day =>
                    days.includes(moment(day).add(1, 'd').format('YYYY-MM-DD')),
                'selected-left': day =>
                    days.includes(
                        moment(day).add(-1, 'd').format('YYYY-MM-DD'),
                    ),
            };
        } else {
            selectedDays = moment(this.props.date, 'YYYY-MM-DD').toDate();
        }

        const initialMonth = moment(this.props.queryDate).isValid()
            ? moment(this.props.queryDate, 'YYYY-MM-DD').toDate()
            : new Date();

        return (
            <div className={`card card-role-timedate ${this.props.className}`}>
                <div className="card-content">
                    <div className="items-container">
                        <DayPicker
                            ref={this.daypickerRef}
                            weekdaysShort={['S', 'M', 'T', 'W', 'T', 'F', 'S']}
                            selectedDays={selectedDays}
                            initialMonth={initialMonth}
                            firstDayOfWeek={1}
                            fixedWeeks={true}
                            fromMonth={new Date(this.props.minStart)}
                            enableOutsideDays={true}
                            modifiers={modifiers}
                            onDayClick={this.handleDayClick}
                            captionElement={({ date }) => (
                                <div className="DayPicker-Caption">
                                    {moment(date).format('MMMM')}
                                </div>
                            )}
                        />
                        <div className="role-time-picker">
                            <span>
                                From
                                <TimePicker
                                    format="HH"
                                    showSecond={false}
                                    showMinute={false}
                                    value={startTime}
                                    onChange={this.onStartChange}
                                />
                                <TimePicker
                                    format="mm"
                                    showSecond={false}
                                    showHour={false}
                                    value={startTime}
                                    onChange={this.onStartChange}
                                    onOpen={this.onMinutePickerOpen}
                                />
                            </span>
                            <span>
                                to
                                <TimePicker
                                    format="HH"
                                    showSecond={false}
                                    showMinute={false}
                                    value={endTime}
                                    onChange={this.onEndChange}
                                />
                                <TimePicker
                                    format="mm"
                                    showSecond={false}
                                    showHour={false}
                                    value={endTime}
                                    onChange={this.onEndChange}
                                    onOpen={this.onMinutePickerOpen}
                                />
                            </span>
                        </div>
                        <div className="role-breaks-container">
                            <label htmlFor="breaks">Break (in mins)</label>
                            <input
                                ref={this.breaksInput}
                                type="number"
                                value={breaks}
                                min={0}
                                onChange={this.breaksHandler}
                                id="breaks"
                                data-testid="breaksInput"
                            />
                        </div>
                        <div className="role-button-container">
                            {mode !== jobModes.EDIT &&
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <label>
                                        <input
                                            className="checkbox-purple"
                                            type="checkbox"
                                            style={{ margin: '5px' }}
                                            checked={!!isMultiple}
                                            onChange={this.handleOngoingToggle}
                                            data-testid="ongoingJobCheckbox"
                                        />
                                        Ongoing Job
                                    </label>
                                </div>
                            }
                        </div>
                        <NumberOfWorkersSpinner
                            number_of_freelancers={this.props.number_of_freelancers}
                            updateField={this.props.updateField}
                        />
                        {mode === jobModes.DUPLICATE &&
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: 20
                            }}>
                                <label>
                                    <input
                                        className="checkbox-purple"
                                        type="checkbox"
                                        style={{ margin: '5px' }}
                                        value={this.props.copyBookings}
                                        onChange={event =>
                                            this.props.changeCopyBookings(event.target.checked)}
                                    />
                                    Copy existing bookings
                                </label>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isMultiple: state.requestData.bookingRequest.isMultiple,
        start_time: state.requestData.bookingRequest.start_time,
        minStart: state.requestData.minStart,
        duration: state.requestData.bookingRequest.duration,
        dates: state.requestData.bookingRequest.dates,
        date: state.requestData.bookingRequest.date,
        number_of_freelancers:
            state.requestData.bookingRequest.number_of_freelancers,
        breaks: state.requestData.bookingRequest.breaks,
    };
}

export default connect(mapStateToProps, {
    toggleOptionCard,
    updateField,
})(AgentTimeDateCard);
